import { useSelector, useDispatch } from "react-redux";
import { setObservations } from "../ducks/shoppingCartSlice";

const MAX_LENGTH = 250;

const ObservationsCard = ({ isAvailableToOrder, orderUuid }) => {
  const dispatch = useDispatch();
  const isSelfcheckoutPOS = useSelector(
    (state) => state.shop.isSelfcheckoutPOS,
  );
  const productOrder = useSelector((state) =>
    state.shoppingCart.productOrders.find((o) => o.uuid === orderUuid),
  );
  if (!productOrder || !isAvailableToOrder || isSelfcheckoutPOS) {
    return null;
  }

  const observations = productOrder.observations || "";

  const onChangeObservations = (event) =>
    dispatch(
      setObservations({
        uuid: orderUuid,
        observations: event.target.value,
      }),
    );

  return (
    <section className="question observations">
      <header className="question__header question__header--static">
        <div className="question__heading">
          <label htmlFor="product-observations" className="question__title">
            Alguma observação?
          </label>
        </div>
        <span className="observations__count" aria-hidden="true">
          {observations.length}/{MAX_LENGTH}
        </span>
      </header>
      <textarea
        id="product-observations"
        className="observations__input"
        rows={3}
        placeholder="Ex.: sem cebola, molho à parte..."
        maxLength={MAX_LENGTH}
        value={observations}
        onChange={onChangeObservations}
      />
    </section>
  );
};

export default ObservationsCard;
